import {createPreview} from '/preview_functions/preview.js';
import { createElement } from "/elements_functions/new_elements.js";
import { createRevealChildrenBottom, createRevealMoreChildrenSide } from '/explore_field_functions/reveal_more_children.js';
import { createIdsForRevealFromVirgins, deduceVirginIds } from '/explore_field_functions/ids_functions.js';
import {  SITE_URL } from "/constants/API_constants.js";
import { createContentRestrictedWindow } from "/restricted_content/restricted_content_functions.js";
import { createPlus18Screen } from '/restricted_content/censorship_screens.js';
import { RenderCheckList } from '/misc_functions/render_check_list.js';

export function createBranchPreview(branchInfo, existingExploreBranchesDictionary=null, buildFunctionsDictionary=null) {
    const branchAndLineage = createElement('div', null, ['explore-window-branch-wrapper']);

    let exploreBranchesDictionary = null;

    if(existingExploreBranchesDictionary!==null) {
        exploreBranchesDictionary = existingExploreBranchesDictionary;
    } else {
        exploreBranchesDictionary = {
            'primary-branch' : null
        };
        branchAndLineage.exploreBranchesDictionary = exploreBranchesDictionary;
    }

    const branch = createBranchForExplore(branchInfo, exploreBranchesDictionary, buildFunctionsDictionary);
    if(existingExploreBranchesDictionary===null) {
        exploreBranchesDictionary['primary-branch'] = branch;
    }

    branchAndLineage.append(branch);

    if(branchInfo.childrenIds!==null && branchInfo.childrenIds!==undefined) {
        let ids;
        let lineageDom = null;
        if(branchInfo.children===null || branchInfo.children.length===0) {
            const virginIds = deduceVirginIds(branchInfo.childrenIds, branchInfo.children);
            ids = createIdsForRevealFromVirgins(virginIds, 3);
            lineageDom = createLineage(null, exploreBranchesDictionary, buildFunctionsDictionary);
            branchAndLineage.append(lineageDom);
            
            const revealBlock = createRevealChildrenBottom(branchAndLineage, ids, buildFunctionsDictionary);
            revealBlock.parentId = branchInfo.id;
            lineageDom.append(revealBlock);
        } else if(branchInfo.children.length===branchInfo.childrenIds.length) {
            lineageDom = createLineage(branchInfo.children, exploreBranchesDictionary, buildFunctionsDictionary);
            branchAndLineage.append(lineageDom);
        } else {
            const virginIds = deduceVirginIds(branchInfo.childrenIds, branchInfo.children);
            ids = createIdsForRevealFromVirgins(virginIds, 3);
            lineageDom = createLineage(branchInfo.children, exploreBranchesDictionary, buildFunctionsDictionary);
            branchAndLineage.append(lineageDom);

            //lineage.insertAdjacentElement('afterbegin', createRevealMoreChildrenSide(branchAndLineage, ids, 'left'));
            const revealBlock = createRevealMoreChildrenSide(branchAndLineage, ids, 'right', buildFunctionsDictionary);
            revealBlock.parentId = branchInfo.id;
            lineageDom.append(revealBlock);
        }

        lineageDom.parentId = branchInfo.id;
    }

    if(branchInfo.parent!==null && branchInfo.parent!==undefined) {
        
        return createParents(branchAndLineage, branchInfo.parent, exploreBranchesDictionary, buildFunctionsDictionary);
    }
    

    return branchAndLineage;

}

function createBranchForExplore(branchInfo, existingExploreBranchesDictionary=null, buildFunctionsDictionary=null) {
    const branch = createElement('div', null, ['explore-window-branch']);
    try {
    
        const modStatus = branchInfo.modStatus;
    
        if(modStatus!=='suspended' && modStatus!=='banned') {
            const renderCheckList = new RenderCheckList('text', 'preview');
            renderCheckList.setOnRenderComplete(() => fadeLongDescription(branch));
    
            branch.renderCheckList = renderCheckList;
    
            const preview = createElement('div', null, ['explore-window-branch-preview']);
            const previewElement = createPreview(branchInfo.preview, () => {
                renderCheckList.check('preview');
            });
            preview.append(previewElement);
    
            
            if(modStatus!==null) {
                if (modStatus==="plus_18") {
                    const black18Screen = createPlus18Screen(previewElement);
    
                    black18Screen.black18ScreenExplanation.remove();
                    black18Screen.black18ScreenQuestion.innerText = "Are you over 18 years old?";
    
                    black18Screen.create18WarningIconInBeginning();
                    black18Screen.makeIconRound();
        
                    preview.append(black18Screen);
                }
            }
        
            const name = createElement('a', null, ['explore-window-branch-name']);
            name.innerText = branchInfo.name;
            name.href = SITE_URL + "/branch/view-page/" + branchInfo.id;
        
            const description = createElement('p', null, ['explore-window-branch-description']);
            description.innerText = branchInfo.description;
        
            branch.append(preview, name, description);
        } else {
            const restrictedBranchWindow = createContentRestrictedWindow('Restricted by the moderation', null, ['explore-window-branch-restricted']);
            branch.append(restrictedBranchWindow);
        }
    
        existingExploreBranchesDictionary[branchInfo.id] = branch;
        
    
    } catch (error) {
        const restrictedBranchWindow = createContentRestrictedWindow('An error occured displaying this branch', null, ['explore-window-branch-restricted']);
        branch.append(restrictedBranchWindow);
    }
    return branch;

}

export function createLineage(children=null, exploreBranchesDictionary=null, buildFunctionsDictionary) {
    const branchHeritage = createElement('div', null, ['explore-window-branch-wrapper-lineage']);
    
    if(children===null)
        return branchHeritage;

    let childrenElements = [];
    for(let child of children) {
        childrenElements.push(createBranchPreview(child, exploreBranchesDictionary, buildFunctionsDictionary));
    }

    branchHeritage.append(...childrenElements);

    return branchHeritage;
}

function createParents(branchAndLineage, firstParent, existingExploreBranchesDictionary=null, buildFunctionsDictionary=null) {
    const parentBranchAndLineage = createElement('div', null, ['explore-window-branch-wrapper']);
    const parentLineage = createLineage(null, existingExploreBranchesDictionary, buildFunctionsDictionary);
    const branch = createBranchForExplore(firstParent, existingExploreBranchesDictionary, buildFunctionsDictionary);

    parentLineage.append(branchAndLineage);

    parentBranchAndLineage.append(branch);
    parentBranchAndLineage.append(parentLineage);

    if(firstParent.parent!==null && firstParent.parent!==undefined) {
        
        return createParents(parentBranchAndLineage, firstParent.parent, existingExploreBranchesDictionary, buildFunctionsDictionary);
    } else {
        parentBranchAndLineage.exploreBranchesDictionary = existingExploreBranchesDictionary;
    }    
    
    return parentBranchAndLineage;
}

export function drawLine(ctx, startX, startY, midX, midY, endX, endY) {
    ctx.beginPath();
    ctx.moveTo(startX, startY);
    ctx.lineTo(startX, midY); // Vertical down from parent
    ctx.lineTo(endX, midY); // Horizontal to child
    ctx.lineTo(endX, endY); // Vertical down to child
    ctx.strokeStyle = "black";
    ctx.lineWidth = 2;
    ctx.stroke();
}

export function getParentBottomCenter(element, container) {
    return {
        x: element.offsetLeft + element.offsetWidth / 2, // Horizontal center
        y: element.offsetTop + element.offsetHeight // Bottom vertical position
    };
}

export function getChildTopCenter(element, container) {
    return {
        x: element.offsetLeft + element.offsetWidth / 2, // Horizontal center
        y: element.offsetTop // Top vertical position
    };
}

function getMargin(element) {
    const styles = window.getComputedStyle(element);
    
    const marginTop = parseInt(styles.marginTop, 10);
    const marginRight = parseInt(styles.marginRight, 10);
    const marginBottom = parseInt(styles.marginBottom, 10);
    const marginLeft = parseInt(styles.marginLeft, 10);

    return {
        marginTop : marginTop,
        marginRight : marginRight,
        marginBottom : marginBottom,
        marginLeft : marginLeft
    }
}

export function createTreeConnectionsForAll(exploreFieldWrapper) {

    const existingConnections = exploreFieldWrapper.querySelectorAll('.explore-window-branch-wrapper-lineage-link');

    for(let i of existingConnections) {
        i.remove();
    }

    const allWrappers = exploreFieldWrapper.querySelectorAll('.explore-window-branch-wrapper');

    for(let wrapper of allWrappers) {
        const linage = wrapper.querySelector('.explore-window-branch-wrapper-lineage');
        
        if(linage) {
            const parent = wrapper.querySelector('.explore-window-branch');
            const children = linage.children;

            const wrapperMargins = getMargin(wrapper);

            const wrapperMarginRight = wrapperMargins.marginRight;
            const wrapperMarginLeft = wrapperMargins.marginLeft;

            // Create and configure canvas
            const canvas = document.createElement("canvas");
            canvas.classList.add("explore-window-branch-wrapper-lineage-link");
            canvas.width = wrapper.offsetWidth - wrapperMarginRight - wrapperMarginLeft;
            canvas.height = 50;
        
            const ctx = canvas.getContext("2d");
        
            const parentCenter = getParentBottomCenter(parent, wrapper);
        
            for(let child of children) {
                const childCenter = getChildTopCenter(child, wrapper);
        
                // Midpoint for the zig-zag connection
                const midY = parentCenter.y + (childCenter.y - parentCenter.y) / 2;
        
                drawLine(ctx, parentCenter.x, 0, parentCenter.x, canvas.height/2, childCenter.x, canvas.height);
            }
        
            parent.insertAdjacentElement('afterend', canvas);
        }
    }
}

export function truncateNameAndDescription(exploreFieldWrapper) {
    const allNames = exploreFieldWrapper.querySelectorAll('.explore-window-branch-name');
    const allBranches = exploreFieldWrapper.querySelectorAll('.explore-window-branch');

    for(let i of allNames)
        truncateText(i, 18);

    for(let i of allBranches) {
        const renderCheckList = i.renderCheckList;
        if(renderCheckList)
            i.renderCheckList.check('text');
    }

}

function truncateText(el, maxLetters) {
    
    let originalText = el.innerText;
    
    while (originalText.length > maxLetters) {
        el.innerText = originalText + '...';
        originalText = originalText.slice(0, -1);
    }
}

function fadeLongDescription(branchElement) {
    

    if (branchElement.scrollHeight > branchElement.clientHeight) {
        const collapseGradient = createElement('div', null, ['explore-window-branch-collapsed-gradient']);
        branchElement.classList.add('explore-window-branch-collapsed');
        branchElement.append(collapseGradient);
      }
}
